// extracted by mini-css-extract-plugin
export default {"text":"Button_text__KKh7+","button":"Button_button__L7pdw"};